import Vue from 'vue'
import Router from 'vue-router'
import entry from '@/components/entry'

import eventEditor from '@/components/eventEditor.vue';
import attenderEditor from '@/components/attenderEditor.vue';
import sessionEditor from '@/components/sessionEditor.vue';
import allocationEditor from '@/components/allocationEditor.vue';
import budgetEditor from '@/components/budgetEditor.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'entry',
      component: entry
    },
    {
      path: '/eventEditor',
      name: 'eventEditor',
      component: eventEditor
    },
    {
      path: '/attenderEditor',
      name: 'attenderEditor',
      component: attenderEditor
    },
    {
      path: '/sessionEditor',
      name: 'sessionEditor',
      component: sessionEditor
    },
    {
      path: '/allocationEditor',
      name: 'allocationEditor',
      component: allocationEditor
    },
    {
      path: '/budgetEditor',
      name: 'budgetEditor',
      component: budgetEditor
    },
    {
      path: '/attendmeeting', // 是否参会
      name: 'attendMeeting',
      component:resolve => require(['@/pages/attendmeeting'],resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js